var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner'),_c('BrandsLogos'),_c('About'),_c('OurOffer'),_c('Process'),_c('TypeDiv'),_c('Values'),_c('Portfolio'),_c('Const')],1)}
var staticRenderFns = []

export { render, staticRenderFns }